'use strict';

let requireOrNull = require;
if (!process.env.WEBPACK) {
  requireOrNull = str => str;
}

const critModules = [
  {
    name: 'EventPipe',
    module: requireOrNull('../../../../modules/deal/frontend/event_pipe'),
  },
  {
    name: 'ReloadGIGBindings',
    module: requireOrNull(
      '../../../../modules/deal/frontend/reload_gig_bindings'
    ),
    featureCheck: serverObj => serverObj.isShellContentReq,
  },
  {
    name: 'BuyButton',
    module: requireOrNull('../../../../modules/buy_button/frontend/buy_button'),
  },
  {
    name: 'Carousel',
    module: requireOrNull('../../../../modules/carousel/frontend/desktop'),
  },
  {
    name: 'Discount',
    module: requireOrNull('../../../../modules/discount/frontend/index'),
  },
  {
    name: 'Variations',
    module: requireOrNull(
      '../../../../modules/variations/frontend/variations-widget'
    ),
    featureCheck: serverObj => serverObj.variations,
  },
  {
    name: 'ShellPageExperiment',
    module: requireOrNull('../../../../modules/deal/shell/frontend/experiment'),
  },
];

const nonCritModules = [
  {
    name: 'DealLazyLoader',
    module: requireOrNull('../../../../modules/deal/frontend/deal_lazy_loader'),
  },
  {
    name: 'Gift',
    module: requireOrNull('../../../../modules/gift_button/frontend/gift'),
  },
  {
    name: 'UrgencyMessaging',
    module: requireOrNull(
      '../../../../modules/urgency_messaging/frontend/urgency_messaging'
    ),
    featureCheck: serverObj =>
      serverObj.urgencyMessaging &&
      serverObj.urgencyMessaging.realTimeMessaging,
  },
  {
    name: 'UrgencyTimer',
    module: requireOrNull(
      '../../../../modules/urgency_messaging/frontend/countdown_timer'
    ),
  },
  {
    name: 'ChannelTabs',
    module: requireOrNull('../../../../modules/deal/frontend/channel_tabs'),
  },
  {
    name: 'ExternalLinks',
    module: requireOrNull('../../../../modules/deal/frontend/external_links'),
  },
  {
    name: 'ExternalDeal',
    module: requireOrNull(
      '../../../../modules/external_deal/frontend/external_deal'
    ),
    featureCheck: serverObj => serverObj.externalDeal,
  },
  {
    name: 'Sharing',
    module: requireOrNull('../../../../modules/sharing/frontend/facebook'),
  },
  {
    name: 'MemberOnly',
    module: requireOrNull('../../../../modules/member_only/frontend/main'),
    featureCheck: serverObj => serverObj.memberOnly,
  },
  {
    name: 'FixAlly',
    module: requireOrNull('../../scripts/vendor_modules/fix-a11y'),
  },
  {
    name: 'Select Widget',
    module: requireOrNull('../../../../modules/select_widget/frontend/desktop'),
    featureCheck: serverObj => serverObj.selectWidget,
  },
  {
    name: 'PromoCodeV2',
    module: requireOrNull('../../../../modules/promo_code_v2/frontend/desktop'),
  },
];

const pageReadyModules = [
  {
    name: 'pageReady',
    module: requireOrNull('../../../../modules/deal/frontend/page_ready'),
  },
];

module.exports = { critModules, nonCritModules, pageReadyModules };
